import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

const HeroCountdown = ({
  bannerSrc,
  backgroundSrc,
  serverNow,
  activePredictMode,
  onScorePredictClick,
  onResultPredictClick,
  showPredictModeSwitch = true
}) => {
  const WORLD_CUP_KICKOFF_MS = dayjs('2026-06-12T02:00:00+07:00').valueOf();

  const [liveServerNowMs, setLiveServerNowMs] = useState(() => {
    const parsed = dayjs(serverNow);
    return parsed.isValid() ? parsed.valueOf() : Date.now();
  });

  useEffect(() => {
    const parsed = dayjs(serverNow);
    if (parsed.isValid()) {
      setLiveServerNowMs(parsed.valueOf());
    }
  }, [serverNow]);

  useEffect(() => {
    const tickTimer = setInterval(() => {
      setLiveServerNowMs((prev) => prev + 1000);
    }, 1000);

    return () => {
      clearInterval(tickTimer);
    };
  }, []);

  const countdownTarget = WORLD_CUP_KICKOFF_MS;

  return (
    <>
      <div className="text-center mt-2 md:mt-4 uppercase leading-none">
        <img
          src={bannerSrc}
          alt="dudoancuchay"
          className="mx-auto w-full max-w-[460px] md:max-w-[760px]"
        />
      </div>

      <div
        className="mt-3 mx-auto relative overflow-hidden w-full max-w-[460px] md:max-w-[620px] h-[176px] md:h-[220px] rounded-[22px] bg-no-repeat bg-center bg-[length:106%_100%] px-[6px] sm:px-[10px] md:px-[16px] pt-[76px] md:pt-[94px] pb-[12px] md:pb-[16px]"
        style={{ backgroundImage: `url(${backgroundSrc})` }}
      >
        <div className="absolute left-[58px] right-[58px] bottom-[8px] md:left-[88px] md:right-[88px] md:bottom-[20px]">
          <Countdown
            date={countdownTarget}
            now={() => liveServerNowMs}
            renderer={({ days, hours, minutes, seconds, completed }) => {
              const values = completed ? [0, 0, 0, 0] : [days, hours, minutes, seconds];
              const labels = ['Ngày', 'Giờ', 'Phút', 'Giây'];

              return (
                <div className="w-full grid grid-cols-4 gap-[3px] sm:gap-[6px] md:gap-[8px]">
                  {values.map((value, idx) => (
                    <div
                      key={labels[idx]}
                      className="w-full h-[60px] sm:h-[76px] md:h-[84px] rounded-[6px] md:rounded-[8px] bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px]"
                    >
                      <div className="h-full w-full rounded-[5px] md:rounded-[7px] text-white text-center flex flex-col items-center justify-center bg-gradient-to-b from-[#22bf48] to-[#0b8f2f]">
                        <strong className="block leading-none text-[22px] sm:text-[34px] md:text-[40px] font-extrabold">
                          {value}
                        </strong>
                        <span className="block leading-none font-bold text-[11px] sm:text-[15px] md:text-[16px] mt-[1px]">
                          {labels[idx]}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              );
            }}
          />
        </div>
      </div>

      {showPredictModeSwitch ? (
        <div className="mt-2 md:mt-3 flex items-center justify-center gap-2">
          {activePredictMode === 'score' ? (
            <div className="rounded-[9px] bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px] md:rounded-[11px] md:p-[2px]">
              <button
                type="button"
                onClick={onScorePredictClick}
                className="h-[32px] md:h-[38px] min-w-[112px] md:min-w-[132px] rounded-[8px] border-none appearance-none bg-gradient-to-b from-[#00CD32] to-[#048724] px-4 text-[14px] md:text-[20px] font-bold uppercase text-white outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
              >
                Dự đoán tỉ số
              </button>
            </div>
          ) : (
            <button
              type="button"
              onClick={onScorePredictClick}
              className="h-[32px] md:h-[38px] min-w-[112px] md:min-w-[132px] rounded-[8px] border-none appearance-none bg-[#9ea3a7] px-4 text-[14px] md:text-[20px] font-bold uppercase text-white outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
            >
              Dự đoán tỉ số
            </button>
          )}

          {activePredictMode === 'result' ? (
            <div className="rounded-[9px] bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px] md:rounded-[11px] md:p-[2px]">
              <button
                type="button"
                onClick={onResultPredictClick}
                className="h-[32px] md:h-[38px] min-w-[112px] md:min-w-[132px] rounded-[8px] border-none appearance-none bg-gradient-to-b from-[#00CD32] to-[#048724] px-4 text-[14px] md:text-[20px] font-bold uppercase text-white outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
              >
                Dự đoán WC 2026
              </button>
            </div>
          ) : (
            <button
              type="button"
              onClick={onResultPredictClick}
              className="h-[32px] md:h-[38px] min-w-[112px] md:min-w-[132px] rounded-[8px] border-none appearance-none bg-[#9ea3a7] px-4 text-[14px] md:text-[20px] font-bold uppercase text-white outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
            >
              Dự đoán WC 2026
            </button>
          )}
        </div>
      ) : null}
    </>
  );
};

export default HeroCountdown;

